<template>
  <component :is="component_prop.type" :prop_data="component_prop" />
</template>
<script>
/*import Vue from 'vue'
import { use } from 'echarts/core'
import { SVGRenderer } from 'echarts/renderers'
import { PieChart, BarChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components'
import { THEME_KEY } from 'vue-echarts'
use([
  SVGRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  BarChart
])*/
export default {
  props: ['svgInfoData', 'component_prop'],

  /* created(){
    this.svgInfoData.forEach(f => {
      let componentInfo = {
        template: f.template,
        props: f.props
      }
      Vue.component(f.type, componentInfo)
    })
  },*/
  watch: {
    component_prop: (val) => {
      console.log(val)
    }
  }
}
</script>
